module.exports = __webpack_public_path__ + "img/enterpriseinfo.c7b071e0.svg";